import React, { useMemo } from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconTemplate } from '../../../../../../shared/icon/icon'
import { Route, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { NodeLibraryEdit } from './node-library-edit'
import { useApiListAssetUnityPackage } from '../../../../../../api-new/state/content'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { NodeLibraryMove } from './node-library-move'
import { NodeLibraryDelete } from './node-library-delete'
import { LoginSysAdmin } from '../../../../../../role/components/login-sys-admin'
import { NodeLibraryEditSys } from './node-library-edit-sys'
import { NodeLibraryCopy } from './node-library-copy'
import { LibraryMenu } from '../../common/menu/node-actions'
import { NodeLibraryAddUnityPackage } from './node-library-add-unity-package'
import { AssetUnityPackage } from '../common/asset-unity-package'
import { PermissionNode } from '../../common/permission/permission-node'
import { useDataContext } from '../data-context'

export const NodeLibraryDetails = ({ parentURL }) => {
  const { url } = useRouteMatch()
  const { nodeID } = useParamsInt()

  const dataContext = useDataContext()

  let library = useMemo(() => dataContext.libraries.find(i => i.id === nodeID), [dataContext.libraries, nodeID])

  const apiListAssetUnityPackage = useApiListAssetUnityPackage()

  const handleMatch = () => apiListAssetUnityPackage.get(`${nodeID}/node`)

  const handleUploadComplete = async (asset, file) => {
    asset.name = file.name
    asset.length = file.size
    await apiListAssetUnityPackage.put(asset.id, asset)
  }

  const title = useMemo(() => (library ? library.name : ''), [library])

  const HeaderMenu = () => <LibraryMenu place="header" url={url} />

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconTemplate} text={title} onMatch={handleMatch}>
        <CardFullHeightScrollY title={title} HeaderMenu={HeaderMenu}>
          {apiListAssetUnityPackage.items.map((asset, i) => <AssetUnityPackage key={i} asset={asset} onUploadComplete={handleUploadComplete} />)}
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <PermissionNode url={url} nodeID={nodeID} />

      <Route path={`${url}/edit`}>
        <NodeLibraryEdit parentURL={url} nodeID={nodeID} />
      </Route>

      <LoginSysAdmin>
        <Route path={`${url}/edit-sys`}>
          <NodeLibraryEditSys parentURL={url} nodeID={nodeID} />
        </Route>
      </LoginSysAdmin>

      <Route path={`${url}/move`}>
        <NodeLibraryMove parentURL={url} nodeID={nodeID} />
      </Route>

      <Route path={`${url}/copy`}>
        <NodeLibraryCopy parentURL={url} nodeID={nodeID} />
      </Route>

      <LoginSysAdmin>
        <Route path={`${url}/add-unity-package`}>
          <NodeLibraryAddUnityPackage parentURL={url} nodeID={nodeID} />
        </Route>
      </LoginSysAdmin>

      <Route path={`${url}/delete`}>
        <NodeLibraryDelete grandParentURL={parentURL} parentURL={url} nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
